export const projectVars = {
  alias: 'cura-interior',
  name: 'Cura Interior',
  systemLang: 'br',
  languages: [
    { label: 'BR', alias: 'br' }
  ]
};
